export default "/images/vendor/flag-icons/flags/4x3/es.svg?e3db1b5f8a2ec8ae87640f32237c01b3";